import React from 'react';
import PropTypes from 'prop-types';

import CombinationChart from './CombinationCharts';
import Title from '../shared/Title';
import { SimplePossessionsFilter } from './SimplePossessionsFilter';
import NoData from '../shared/NoData';
import Spinner from '../shared/Spinner';

import { pathTo } from '../../App/routes';
import { createOverflow, checkIfNBA } from '../../lib/format';

const CombinationExplorer = ({
  team,
  report,
  combinationFilter,
  possessionsFilter,
  simplePossessionsFilter,
  season,
}) => {
  const { hasData, players, data, config } = report;
  const overflow = createOverflow(team, season);
  const isNBA = checkIfNBA(team);

  return (
    <div>
      <Title
        team={team}
        linkTo={pathTo('team')}
        subtitle={'Combination Explorer'}
        overflow={overflow}
      />

      {!isNBA && (
        <div className="s-combination-explorer__context-warning">
          <p>Numbers Shown Are In-Division Contests Only</p>
        </div>
      )}

      <SimplePossessionsFilter
        {...simplePossessionsFilter}
        disabled={!hasData}
      />

      {hasData ? (
        <div className="s-combination-explorer__data-container box box--has-border">
          {(!data || !data.length) && <NoData />}

          <CombinationChart
            config={config.offense}
            data={data}
            players={players}
          />
          <CombinationChart
            config={config.defense}
            data={data}
            players={players}
          />
          <CombinationChart
            config={config.synergy}
            data={data}
            players={players}
          />
          <CombinationChart config={config.net} data={data} players={players} />
        </div>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

CombinationExplorer.propTypes = {
  team: PropTypes.object,
  stats: PropTypes.array,
};

export default CombinationExplorer;
